import Utils from './Utils';

export default class SliderNavigationHelper {
    constructor() {
        let utils = new Utils();
        this.passiveSupported = utils.isPassiveEventHandlerSupported();
    }

    addFollowMouseListener(next, prev, item) {
        const cursor = item.querySelectorAll('.cursor')[0];

        document.addEventListener('mousemove', (e) => {
            this.handleMouseMove('outside', e.pageX, e.pageY, cursor);
        }, this.passiveSupported ? { passive: true } : false);

        next.addEventListener('mousemove', (e) => {
            this.handleMouseMove('next', e.pageX, e.pageY, cursor);
        });

        next.addEventListener('mouseout', (e) => {
            cursor.style.width = '0px';
            cursor.style.height = '0px';
        });

        prev.addEventListener('mousemove', (e) => {
            this.handleMouseMove('prev', e.pageX, e.pageY, cursor);
        });

        prev.addEventListener('mouseout', (e) => {
            cursor.style.width = '0px';
            cursor.style.height = '0px';
        });

        window.addEventListener('scroll', (e) => {
            if (document.body.classList.contains('modal-open')) {
                if (window.document.querySelectorAll('.modal.show')[0] && this.lastScrolledTop != window.document.querySelectorAll('.modal.show')[0].scrollTop) {
                    this.yMousePos += this.lastScrolledTop;
                    this.lastScrolledTop = window.document.querySelectorAll('.modal.show')[0].scrollTop;
                    this.yMousePos -= this.lastScrolledTop;
                }
            } else {
                if (this.lastScrolledTop != window.scrollY) {
                    this.yMousePos -= this.lastScrolledTop;
                    this.lastScrolledTop = window.scrollY;
                    this.yMousePos += this.lastScrolledTop;
                }
            }
            // if (this.lastScrolledTop != window.scrollY) {
            //     this.yMousePos -= this.lastScrolledTop;
            //     this.lastScrolledTop = window.scrollY;
            //     this.yMousePos += this.lastScrolledTop;
            // }
            if(this.checkIfInside(next, prev, cursor)){
                this.handleMouseMove(this.lastControl, this.xMousePos, this.yMousePos, cursor);
                cursor.style.width = '70px';
                cursor.style.height = '70px';
            }
            else {
                cursor.style.width = '0px';
                cursor.style.height = '0px';
                next.style.cursor = 'default';
                prev.style.cursor = 'default';
                setTimeout(function(){
                    next.style.cursor = 'none';
                    prev.style.cursor = 'none';
                }, 1);
            }
        }, this.passiveSupported ? { passive: true } : false);
    }

    handleMouseMove(prevOrNext, mouseX, mouseY, cursor) {
        this.xMousePos = mouseX;
        this.yMousePos = mouseY;

        if(prevOrNext == 'outside') { return; }

        this.lastControl = prevOrNext;

        cursor.style.left = mouseX + 'px';
        if (document.body.classList.contains('modal-open')) {
            cursor.style.top = (mouseY - window.scrollY + document.querySelectorAll('.modal.show')[0].scrollTop) + 'px';
        } else {
            cursor.style.top = (mouseY - window.scrollY) + 'px';
        }
        cursor.style.width = '70px';
        cursor.style.height = '70px';
        if (prevOrNext == 'next') {
            cursor.style.backgroundImage = "url(/out/weka/img/sliderarrow-right.svg)";
        } else {
            cursor.style.backgroundImage = "url(/out/weka/img/sliderarrow-left.svg)";
        }
    }

    checkIfInside(next, prev, cursor) {
        let nextRect = next.getBoundingClientRect();
        if (this.yMousePos - window.scrollY >= nextRect.top && this.yMousePos - window.scrollY <= nextRect.bottom &&
            this.xMousePos >= nextRect.left && this.xMousePos <= nextRect.right && !next.classList.contains('swiper-button-disabled')) {
            // Mouse is inside element.
            this.lastControl = 'next';
            cursor.style.backgroundImage = "url(/out/weka/img/sliderarrow-right.svg)";
            return true;
        }
       let prevRect = prev.getBoundingClientRect();
       if (this.yMousePos - window.scrollY >= prevRect.top && this.yMousePos - window.scrollY <= prevRect.bottom &&
           this.xMousePos >= prevRect.left && this.xMousePos <= prevRect.right && !prev.classList.contains('swiper-button-disabled')) {
           // Mouse is inside element.
           this.lastControl = 'prev';
           cursor.style.backgroundImage = "url(/out/weka/img/sliderarrow-left.svg)";
           return true;
       }
        return false;
    }
}
